import { parsePipeList } from "../../utils";
import { TEXTS } from "../../constants";
import {
  SectionWrapper,
  ContentWrapper,
  SectionHeading,
  CredentialsGrid,
  CredentialCard,
  CardTitle,
  ListContainer,
  ListItemText,
  LanguagesContainer,
  LanguageChip,
} from "./styles";

const CredentialList = ({ title, items }) => {
  const parsed = parsePipeList(items);
  if (!parsed.length) return null;

  return (
    <CredentialCard>
      <CardTitle>{title}</CardTitle>
      <ListContainer>
        {parsed.map((item, idx) => (
          <ListItemText key={idx}>{item}</ListItemText>
        ))}
      </ListContainer>
    </CredentialCard>
  );
};

const LanguagesList = ({ languages }) => {
  const parsed = parsePipeList(languages);
  if (!parsed.length) return null;

  return (
    <CredentialCard>
      <CardTitle>{TEXTS.credentials.languages}</CardTitle>
      <LanguagesContainer>
        {parsed.map((lang, idx) => (
          <LanguageChip key={idx} label={lang} />
        ))}
      </LanguagesContainer>
    </CredentialCard>
  );
};

const CredentialsSection = ({ practitionerData }) => {
  const {
    education,
    certifications,
    memberships,
    practitionerTypes,
    languages,
  } = practitionerData;

  const hasAny =
    education ||
    certifications ||
    memberships ||
    practitionerTypes ||
    languages;

  if (!hasAny) return null;

  return (
    <SectionWrapper>
      <ContentWrapper>
        <SectionHeading>{TEXTS.credentials.title}</SectionHeading>
        <CredentialsGrid>
          <CredentialList
            title={TEXTS.credentials.education}
            items={education}
          />
          <CredentialList
            title={TEXTS.credentials.certifications}
            items={certifications}
          />
          <CredentialList
            title={TEXTS.credentials.memberships}
            items={memberships}
          />
          <CredentialList
            title={TEXTS.credentials.practitionerTypes}
            items={practitionerTypes}
          />
          <LanguagesList languages={languages} />
        </CredentialsGrid>
      </ContentWrapper>
    </SectionWrapper>
  );
};

export default CredentialsSection;
